<template>
<div>
    <header v-bind:class="{'header': ($route.name !== 'feed' || $route.name !== 'post'), 'blog-header': ($route.name === 'feed' || $route.name === 'post')}">
      <div class="container pt-4">
        <nav class="navbar navbar-expand-lg navbar-dark bg-transparent px-0">
          <router-link to="/home/team">
          <a class="text-white navbar-brand smooth-scroll">About</a>
          </router-link>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#da-navbarNav" aria-controls="da-navbarNav" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
          <div class="collapse navbar-collapse text-uppercase" id="da-navbarNav">
            <ul class="navbar-nav ml-auto">
                <router-link tag="li" to="/home/main">
                  <a class="nav-link">Home</a>
                </router-link>
                <router-link tag="li" to="/home/services">
                  <a class="nav-link">Services</a>
                </router-link>
                <router-link tag="li" to="/home/projects">
                  <a class="nav-link">Approach</a>
                </router-link>
                <router-link tag="li" to="/home/contact">
                  <a class="nav-link">Contact</a>
                </router-link>
                <router-link tag="li" to="/blog">
                  <a class="nav-link" data-toggle="collapse" data-target="#da-navbarNav">Blog</a>
                </router-link>
            </ul>
          </div>
        </nav>
        <div class="da-home-page-text" data-aos="fade-right" data-aos-duration="1000">
        <div class="container">
          <div class="col-md-10 col-sm-12 px-0 mx-0">
            <h2 class="display-3" style="margin-left:-6px;">Reaching Potential Psychology</h2>
            <h3 class="h5 mt-3">Empowering wonderful people to reach the happiness they deserve</h3>
            <router-link tag="h3" to="/home/learn">
                  <a class="btn btn-outline-light mt-4">Learn More</a>
              </router-link>
          </div>
        </div>
      </div>
      </div>
    </header>
    <router-view></router-view>
    <footer class="bg-secondary da-section">
      <div class="container text-white">
        <div class="row">
          <div class="col-md-4">
            <div class="h2">Contact</div>
            <p class="mb-0">reachingpotential.auckland@gmail.com</p>
            <p>021-02856250</p>
          </div>
          <div class="col-md-4">
            <!-- <div class="h6 pb-2">Follow Us</div> -->
            <ul>
              <!-- <li><a class="da-social-link" href="#">Facebook</a></li>
              <li><a class="da-social-link" href="#">Instagram</a></li> -->
            </ul>
          </div>
          <div class="col-md-4">
            <div class="h6 pb-2">Copyright</div>
            <p>&copy; 2021 Reaching Potential Limited. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
    <div id="scrolltop">
      <!-- <button class="btn btn-primary"><span class="icon"><i class="fas fa-angle-up fa-2x"></i></span></button> -->
      <button class="btn btn-primary"><span class="icon"><font-awesome-icon icon="angle-up" size="2x"/></span></button>
    </div>
  </div>
</template>

<script>
import AOS from 'aos'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp'

library.add(faAngleUp)

export default {
mounted() {
// Add your javascript here
// Don't forget to add it into respective layouts where this js file is needed
// $(document).ready(function() {
//   AOS.init( {
//     // uncomment below for on-scroll animations to played only once
//     // once: true  
//   }); // initialize animate on scroll library
// });


// Smooth scroll for links with hashes
// $("a.smooth-scroll").click(function(event) {
//   // On-page links
//   if (
//     location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") &&
//     location.hostname == this.hostname
//   ) {
//     // Figure out element to scroll to
//     var target = $(this.hash);
//     target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
//     // Does a scroll target exist?
//     if (target.length) {
//       console.log(target)
//       // Only prevent default if animation is actually gonna happen
//       event.preventDefault();
//       $("html, body").animate(
//         {
//           scrollTop: target.offset().top
//         },
//         1000,
//         function() {
//           // Callback after animation
//           // Must change focus!
//           var $target = $(target);
//           $target.focus();
//           if ($target.is(":focus")) {
//             // Checking if the target was focused
//             return false;
//           } else {
//             $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
//             $target.focus(); // Set focus again
//           }
//         }
//       );
//     }
//   }
// });


// Light Box
// $(document).on("click", '[data-toggle="lightbox"]', function(event) {
//   event.preventDefault();
//   $(this).ekkoLightbox();
// });

// // Scroll Top
// $(function () {
//   $('[data-toggle="tooltip"]').tooltip()

//   $("#scrolltop").click(function () {
//     $("html,body").animate({ scrollTop: $("#top").offset().top }, "1000");
//     return false
//   })
// })

// $(window).scroll(function () {
//   if ($(this).scrollTop() > 500) {
//     $('#scrolltop:hidden').stop(true, true).fadeIn();
//   } else {
//     $('#scrolltop').stop(true, true).fadeOut();
//   }
//   });
  }
}
</script>
<style src='./assets/css/aos.css'></style>
<style src='./assets/css/ekko-lightbox.css'></style>
<style src='./assets/css/bootstrap.css'></style>

